var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriorityHighWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3.8L1.4 9.4L0 8L8 0L16 8L14.6 9.4L9 3.8V20H7V3.8Z",
    fill: "#F1F5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityHighWhite);
export default __webpack_public_path__ + "static/media/priority-high-white.4ea990a978980ad09ed10a3e38a491e1.svg";
export { ForwardRef as ReactComponent };